import { Component, OnInit, ElementRef, ViewChild, Input, Self, Output, EventEmitter } from '@angular/core';
import { NgControl, Validators, AbstractControl } from '@angular/forms';
import { GlAccountService } from 'src/app/services/gl-account.service';
import { GLAccount } from 'src/app/interfaces/gl-account.interface';

@Component({
  selector: 'select-field-gl-account',
  templateUrl: './select-field-gl-account.component.html',
  styleUrls: ['./select-field-gl-account.component.scss']
})
export class SelectFieldGlAccountComponent implements OnInit {

  @ViewChild('select', {static: true}) select: ElementRef;

  // inputs
  @Input() label: string = 'G/L Account';
  @Input() required: boolean = false;
  @Input() fieldError: string;
  @Input() isSubmitted = false;
  @Input() valueProp = 'Id';

  @Output() ready: EventEmitter<any> = new EventEmitter();

  loading = true;

  // options data
  options: GLAccount[];

  constructor(
    @Self() public ngCtrl: NgControl,
    private _glAccountSvc: GlAccountService
  ) {
    ngCtrl.valueAccessor = this;
  }

  ngOnInit() {

    const ctrl = this.ngCtrl.control;
    this.select.nativeElement.value = '';

    this._glAccountSvc.getGLAccounts();
    this._glAccountSvc.GLAccounts.subscribe((res: GLAccount[]) => {
      if (res) {
        this.options = res;
        this.loading = false;
        this.ready.emit();
        if (ctrl.value) {
          setTimeout(() => {
            this.writeValue(ctrl.value);
          }, 50);
        }
      }
    });

  }

  onSelectChange(value: any) {
    this.onChange(value);
  }

  onChange(_value: any) {}

  onTouched() {}

  writeValue(value: any) {
    this.select.nativeElement.value = value;
  }

  registerOnChange(fn: (value: any) => void) {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void) {
    this.onTouched = fn;
  }

  validate(ctrl: AbstractControl) {
    return Validators.required(ctrl);
  }

}
